import React, { useMemo } from "react";
import { PieChart as BasePieChart, getToolTipFormater, getDependencies } from "@gago/pie-chart";
import styled from "styled-components";
import {
  ColorProps, SubColor, ChartProps, ITable, ICSSProps, PrimaryColor, MainBlackTransparentColor, FlipNumbers,
  ChartStyleProps,
  getTransparentColor,
} from "@gago/frame";
import chartsPieBg from "./charts-pie-bg.svg";

// tslint:disable: variable-name jsx-no-multiline-js
const Root = styled.div<ColorProps<PrimaryColor>>`
  width: 100%;
  height: 100%;
  display: flex;
  .pie-padding{
    height: 100%;
    flex: 0 0 200px;
    padding: 0px 20px 0px 0px;
    .pie-background{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      z-index: -2;
      background-image: url(${chartsPieBg});
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
    .pie-center{
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      .pie-title{
        font-size: 36px;
        color: ${p => p.colorPalette.mainColor[1]};
        font-family: BebasNeue;
      }
      .pie-subtitle{
        font-size: 16px;
        color: ${p => p.colorPalette.mainColor[3]};
        font-family: BebasNeue;
      }
    }
  }
  .legend-box{
    flex: 1 1 230px;
    display: flex;
    justify-content: center;
    align-items: center;
    .legend-border{
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    .legend-item{
      flex: 0 0 auto;
      height: 32px;
      width: 106px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 16px;
      .legend-color{
        height: 8px;
        width: 8px;
        border-radius: 6px;
        margin-right: 3px;
      }
      .legend-value{
        font-size: 14px;
        color: #00cae0;
      }
    }
  }
`;

export type PieChartProps = ChartProps<1, 1> &
  ColorProps<
    SubColor & PrimaryColor & MainBlackTransparentColor
  > &
  ChartStyleProps &
  ICSSProps &
{
  /** 图例中显示百分比 */
  legendShowPercent?: boolean;
};

/** 饼图
 * @author James Zhang
 */
// tslint:disable-next-line: naming-convention
export function PieChartRight(props: PieChartProps) {
  return useMemo(() => {
    const prefix = props.chartData.prefix;
    const suffix = props.chartData.suffix;
    const total = props.chartData.data.map(item => item[2]).reduce((item, current) => item + current, 0);
    const dataPrefix = (prefix && prefix[2]) ? prefix[2] : "";
    const dataSuffix = (suffix && suffix[2]) ? suffix[2] : "";
    let legendData: ITable<3 | 4, 0>["data"] = props.chartData.data.map(item => {
      return [item[0], item[1], `${item[2]}`, dataSuffix, `${((item[2] / total) * 100).toFixed(0)}%`];
    });
    if (props.legendShowPercent !== true) {
      legendData = legendData.map(item => [item[0], item[1], item[2], item[3]]);
    }
    return (
      <Root className={props.className} style={props.style} colorPalette={props.colorPalette}>
        <div className="pie-padding">
          <BasePieChart
            chartData={props.chartData}
            colorPalette={props.colorPalette}
            className="pie"
            radius={["78.4%", "90%"]}
            showLabel={false}
            gapAngle={1}
            useGradient
            tooltipFormatter={getToolTipFormater(props)}
            tooltipBorderColor={getTransparentColor(props.colorPalette.mainColor[2], 4)}
            tooltipBackgroundColor={props.colorPalette.mainBlackTransparentColor[7]}
            tooltipBorderWidth={1}
          >
            <>
              <div className="pie-background" />
              <div className="pie-center">
                <div className="pie-title">
                  {
                    props.chartData.title &&
                    <FlipNumbers
                      color={props.colorPalette.mainColor[1]}
                      height={32}
                      width={14}
                    >
                      {props.chartData.title}
                    </FlipNumbers>
                  }
                </div>
                <div className="pie-subtitle">{props.chartData.subtitle}</div>
              </div>
            </>
          </BasePieChart>
        </div>
        <div className="legend-box">
          <div className="legend-border">
            {legendData.map((item, index) => (
              <div className="legend-item" key={index}>
                <span className="legend-color" style={{ backgroundColor: props.colorPalette.subColor[index] }} />
                <span className="legend-value">{item[1]}</span>
              </div>
            ))}
          </div>
        </div>
      </Root>);
  }, getDependencies(props));
}
